module.exports = __webpack_public_path__ + "static/img/11_4Archive_17c_Kaprowvideotapenotes7Kinds_13.5ceaf19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_17c_Kaprowvideotapenotes7Kinds_13.jpg
// module id = c2yg
// module chunks = 0